import { Modal, Message } from 'iview'

export const confirm = (handler, message, title, cancel) => (...rest) => new Promise((resolve, reject) => Modal.confirm({
  title: title || '提示',
  content: message || '确定执行此操作？',
  onOk: () => handler(...rest).then(resolve, reject),
  onCancel: reject
  /* () => {
      //return Promise.reject.bind(Promise)
    }*/
}))


export const update = (promise, message = '操作成功') => (...rest) => promise(...rest).then(resp => {
  if (resp.code) {
    Message.error({ content: resp.msg })
  } else {
    Message.success(message)
    return Promise.resolve.bind(Promise)
  }
})

export default { confirm, update }
